module.exports = __webpack_public_path__ + "img/h3-2.a139f439.png";